export const CONTRACT_CREATED = "ContractCreated";
export const CONTRACT_UPDATED = "ContractUpdated";
export const RATING_REQUEST = "RatingRequest";
export const CREATE_CONVERSATION = "CreateConversation";
